/**
 * server
 * response.life.edu Backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Message { 
    id?: number;
    name?: string;
    phone?: string;
    template_id?: number;
    sid?: string;
    created?: string;
    sent?: string;
    delivered?: string;
    status?: string;
    sent_by?: string;
    updated?: string;
}

